import axios from 'axios';

export const crearInmueble = async data => {
	try {
		const response = await axios.post('/inmuebles', data, {
			retry: 3,
			retryDelay: 1000,
		});
		return response.data.data;
	} catch (error) {
		console.error(
			'🚀 ~ file: inmuebles.js:8 ~ crearInmueble ~ error',
			error,
		);
		throw error.response;
	}
};

export const getAllInmuebles = async (
	page = undefined,
	limit = undefined,
	filtros = {},
) => {
	try {
		const params = {
			page,
			limit,
			...filtros,
		};
		const response = await axios.get('/inmuebles', {
			params,
			retry: 3,
			retryDelay: 1000,
		});
		return response.data.data;
	} catch (error) {
		console.error(
			'🚀 ~ file: inmuebles.js:18 ~ getAllInmuebles ~ error',
			error,
		);
		throw error.response;
	}
};

export const getInmuebleById = async id => {
	try {
		const response = await axios.get(`/inmuebles/${id}`, {
			retry: 3,
			retryDelay: 1000,
		});
		return response.data.data;
	} catch (error) {
		console.error(
			'🚀 ~ file: inmuebles.js:28 ~ getInmuebleById ~ error',
			error,
		);
		throw error.response;
	}
};

export const updateInmueble = async (id, data) => {
	try {
		const response = await axios.patch(`/inmuebles/${id}`, data, {
			retry: 3,
			retryDelay: 1000,
		});
		return response.data.data;
	} catch (error) {
		console.error(
			'🚀 ~ file: inmuebles.js:38 ~ updateInmueble ~ error',
			error,
		);
		throw error.response;
	}
};

export const deleteInmueble = async id => {
	try {
		const response = await axios.delete(`/inmuebles/${id}`, {
			retry: 3,
			retryDelay: 1000,
		});
		return response.data.data;
	} catch (error) {
		console.error(
			'🚀 ~ file: inmuebles.js:48 ~ deleteInmueble ~ error',
			error,
		);
		throw error.response;
	}
};

export const getInmueblesByCliente = async id => {
	try {
		const response = await axios.get(`/inmuebles/cliente/${id}`, {
			retry: 3,
			retryDelay: 1000,
		});
		return response.data.data;
	} catch (error) {
		console.error(
			'🚀 ~ file: inmuebles.js:28 ~ getInmuebleById ~ error',
			error,
		);
		throw error.response;
	}
};

const readFileAsBase64 = file =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			const result = reader.result || '';
			const str = String(result);
			resolve(str.includes(',') ? str.split(',')[1] : str);
		};
		reader.onerror = () =>
			reject(reader.error || new Error('Error leyendo el archivo'));
		reader.readAsDataURL(file);
	});

/**
 * Subida de UN fichero. MANTIENE el nombre y la ruta original.
 * Firma compatible: (id, filename, data)
 * Extensión no disruptiva: 4º parámetro opcional { onProgress, signal }
 */
export const uploadInmuebleFile = async (id, filename, data, opts = {}) => {
	const { onProgress, signal } = opts;
	try {
		const response = await axios.post(
			`/inmuebles/imagenes/${id}`,
			{ filename, data },
			{
				headers: { 'Content-Type': 'application/json' },
				onUploadProgress: evt => {
					if (!evt.total) return;
					const pct = Math.round((evt.loaded * 100) / evt.total);
					onProgress?.(pct);
				},
				signal,
			},
		);
		return response.data?.data ?? response.data;
	} catch (error) {
		console.log(
			'🚀 ~ services/inmuebles.js ~ uploadInmuebleFile ~ error:',
			error,
		);
		throw error?.response || error;
	}
};

/**
 * Subida de MÚLTIPLES ficheros llamando a la MISMA ruta (una petición por archivo).
 * - files: File[]
 * - options: {
 *     concurrency?: number (por defecto 3),
 *     onItemProgress?: (index, pct) => void,
 *     onItemStart?: (index) => void,
 *     onItemDone?: (index, result) => void,
 *     onItemError?: (index, error) => void,
 *     signal?: AbortSignal
 *   }
 * Devuelve: { results: Array<'fulfilled'|'rejected'> con value/reason }
 */
export const uploadInmuebleFiles = async (id, files, options = {}) => {
	const {
		concurrency = 3,
		onItemProgress,
		onItemStart,
		onItemDone,
		onItemError,
		signal,
	} = options;

	if (!Array.isArray(files) || files.length === 0) {
		return { results: [] };
	}

	// Partimos la lista en chunks de tamaño = concurrency
	const chunks = [];
	for (let i = 0; i < files.length; i += concurrency) {
		chunks.push(files.slice(i, i + concurrency));
	}

	const settled = [];

	for (const chunk of chunks) {
		// Ejecutamos cada chunk en paralelo
		const promises = chunk.map(async file => {
			const index = files.indexOf(file);
			try {
				onItemStart?.(index);
				const base64 = await readFileAsBase64(file);
				const result = await uploadInmuebleFile(id, file.name, base64, {
					onProgress: pct => onItemProgress?.(index, pct),
					signal,
				});
				onItemDone?.(index, result);
				return { status: 'fulfilled', value: result };
			} catch (err) {
				onItemError?.(index, err);
				return { status: 'rejected', reason: err };
			}
		});

		// Esperamos a que terminen las del chunk
		// y acumulamos resultados preservando el orden por finalización
		// (si quieres preservar orden original, puedes mapear por índice)
		const results = await Promise.all(promises);
		settled.push(...results);
	}

	return { results: settled };
};

export const getAllInmuebleFiles = async id => {
	try {
		const response = await axios.get(`/inmuebles/imagenes/${id}`, {
			retry: 3,
			retryDelay: 1000,
		});
		return response.data.data;
	} catch (error) {
		console.log(
			'🚀 ~ file: inmuebles.js:82 ~ getAllInmuebleFiles ~ error:',
			error,
		);
		throw error.response;
	}
};
